<template>
  <div class="doctorPage managerPlan Manager">
    <div class="selectSearch">
      <el-form
        ref="form"
        :model="searchParams"
        class="qcFrom searchConditions"
        :inline="true"
      >
        <el-form-item label="机构名称：" prop="hospCode">
          <el-select
            v-model="searchParams.hospCode"
            placeholder="请选择机构"
            class="multiple"
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in allHospitalsData"
              :key="index"
              :label="item.HospitalName"
              :value="item.HospitalGuid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="添加时间：" prop="addTime">
          <el-date-picker
            v-model="searchParams.addTime"
            type="daterange"
            size="small"
            style="width: 320px;"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="模态：" prop="model">
          <el-select
            size="small"
            v-model="searchParams.model"
            style="width: 100%;"
            placeholder="请选择模态"
            clearable
          >
            <el-option
              v-for="(item, index) in modalityTypeSelect"
              :key="index"
              :label="item.Name"
              :value="item.Name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查项目：" prop="checkItem">
          <el-input
            v-model="searchParams.checkItem"
            size="small"
            placeholder="请输入检查项目"
          ></el-input>
        </el-form-item>
        <el-form-item label="部位：" prop="part">
          <el-input
            v-model="searchParams.part"
            size="small"
            placeholder="请输入部位"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传状态：" prop="imageState">
          <el-select
            v-model="searchParams.imageState"
            size="small"
            placeholder="请选择上传状态"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="已上传" value="1"></el-option>
            <el-option label="未上传" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitSearch" round>
            查询
          </el-button>
          <el-button size="small" @click="reset" round> 重置 </el-button>
        </el-form-item>
        <div class="addbtn-box">
          <a href="javascript:;" @click="addReport" class="addbtn">添加报告</a>
          <a href="javascript:;" @click="batchUploadReport" class="addbtn">
            批量上传报告
          </a>
        </div>
      </el-form>
    </div>
    <div class="centerHome">
      <div class="ccHomel">
        <div class="compentTable">
          <el-table
            class="qcTable scrollbar"
            :data="tableData"
            ref="multipleTable"
            v-loading="loading"
            tooltip-effect="dark"
          >
            <el-table-column
              prop="HospitalName"
              width="120"
              label="机构名称"
            ></el-table-column>
            <el-table-column
              min-width="140"
              prop="AccNo"
              label="检查号"
            ></el-table-column>
            <el-table-column
              prop="ExaminDate"
              label="检查时间"
            ></el-table-column>
            <el-table-column prop="ModalityType" label="模态"></el-table-column>
            <el-table-column
              prop="CheckingItems"
              width="180"
              :show-overflow-tooltip="true"
              label="检查项目"
            ></el-table-column>
            <el-table-column prop="BodyParts" label="部位"></el-table-column>
            <el-table-column
              prop="ScanTypes"
              label="扫描方式"
            ></el-table-column>
            <el-table-column
              prop="PacsUrlState"
              label="影像上传状态"
              width="200"
            >
              <!-- <template slot-scope="scope">
                <span v-if="scope.row.ImageState === 1">已上传</span>
                <span v-else-if="scope.row.ImageState === 2">未上传</span>
                <span v-else>未知</span>
              </template> -->
            </el-table-column>
            <el-table-column prop="" label="操作" fixed="right" width="180">
              <template slot-scope="scope">
                <span
                  class="table-task-btn detail"
                  @click="editReport(scope.row)"
                >
                  编辑
                </span>
                <span
                  class="table-task-btn detail"
                  @click="uploadReport(scope.row)"
                >
                  上传影像
                </span>
                <span
                  v-if="scope.row.PacsUrl"
                  class="table-task-btn detail"
                  @click="viewReport(scope.row)"
                >
                  查看影像
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pages">
            <el-pagination
              class="pageAll"
              align="center"
              layout="prev, pager, next"
              :total="searchParams.TotalCount"
              :page-size="searchParams.pageCount"
              :current-page="searchParams.pageIndex"
              @current-change="currentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <add-report-dialog
      ref="addReportDialog"
      @updateList="getReportList"
      v-model.sync="dialogVisible"
    ></add-report-dialog>
    <upload-dialog
      ref="uploadDialog"
      v-model.sync="dialogUploadVisible"
      @uploadSuccess="getReportList"
    ></upload-dialog>
    <bath-upload-report-dialog
      ref="bathUploadReportDialog"
      v-model.sync="dialogBathUploadVisible"
      @uploadSuccess="getReportList"
    ></bath-upload-report-dialog>
  </div>
</template>
<script>
import Api from "../../../api";
import axios from "@/js/api";
import addReportDialog from "./addReportDialog.vue";
import uploadDialog from "./uploadDialog.vue";
import bathUploadReportDialog from "./bathUploadReportDialog.vue";
import moment from "moment";
export default {
  components: {
    addReportDialog,
    uploadDialog,
    bathUploadReportDialog,
  },
  data() {
    return {
      dialogVisible: false,
      modalityTypeSelect: [],
      dialogUploadVisible: false,
      dialogBathUploadVisible: false,
      loading: false,
      allHospitalsData: [],
      searchParams: {
        hospCode: "",
        model: "",
        pageIndex: 1,
        pageCount: 10,
        TotalCount: 0,
        imageState: "-1",
        addTime: [
          moment()
            .subtract(3, "month")
            .format("YYYY-MM-DD"), // 三个月前
          moment().format("YYYY-MM-DD"), // 当前日期
        ],
      },

      tableData: [],
    };
  },
  computed: {},
  methods: {
    getALLHospitalList() {
      axios
        .ajaxGet("get", Api.api.manager.GetHandReportHospital)
        .then((res) => {
          console.log(res, "222222");
          if (res.status === 200 && res.data) {
            this.allHospitalsData = res.data.Data;
          }
        });
    },
    batchUploadReport() {
      this.dialogBathUploadVisible = true;
    },
    // 查看报告
    viewReport(row) {
      window.open(row.PacsUrl, "_blank");
    },
    // 编辑报告
    editReport(row) {
      this.dialogVisible = true;
      this.$refs.addReportDialog.dialogList = row;
    },
    uploadReport(row) {
      console.log(this.dialogUploadVisible, "row");
      this.dialogUploadVisible = true;
      this.$refs.uploadDialog.GuidList = {
        ReportGuid: row.ReportGuid,
        HospitalGuid: row.HospitalGuid,
      };
    },
    // 表格分页参数改变
    currentChange(val) {
      this.searchParams.pageIndex = val;
      this.getReportList();
      //   this.getDataExportList();
      // document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    submitSearch() {
      this.searchParams.pageIndex = 1;
      this.getReportList();
    },
    // 获取列表
    getReportList() {
      this.loading = true;
      let params = {
        hospCode: this.searchParams.hospCode,
        pageIndex: this.searchParams.pageIndex,
        pageSize: this.searchParams.pageCount,
        imageState: this.searchParams.imageState,
        startTime: this.searchParams.addTime.length
          ? this.searchParams.addTime[0]
          : "",
        endTime: this.searchParams.addTime.length
          ? this.searchParams.addTime[1]
          : "",
        model: this.searchParams.model,
        checkItem: this.searchParams.checkItem,
        part: this.searchParams.part,
      };
      axios
        .ajaxGet("get", Api.api.manager.GetReportHandList, params)
        .then((res) => {
          this.loading = false;
          console.log(res, "ssssssssss");
          if (res.status === 200 && res.data.StatusCode === 200) {
            this.tableData = res.data.Data;
            this.searchParams.TotalCount = res.data.Total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    addReport() {
      this.dialogVisible = true;
      this.$refs.addReportDialog.dialogList = {
        HospitalGuid: "",
        AccNo: "",
        PatientNo: "",
        PatientName: "",
        Gender: "",
        CurrentAge: "",
        ModalityType: "",
        WysText: "",
        WygText: "",
        IsPositive: "",
        HealthHistory: "",
        ReportSubmitDt: "",
        ReportSubmitterName: "",
        FirstApproveDt: "",
        FirstApproverName: "",
        ExaminDate: "",
        TechnicianName: "",
      };
    },
    GetReportModality() {
      axios.ajaxGet("get", Api.api.manager.GetReportModality).then((res) => {
        if (res.status == 200 && res.data.StatusCode == 200) {
          this.modalityTypeSelect = res.data.Data;
        }
      });
    },
    reset() {
      (this.searchParams = {
        hospCode: "",
        model: "",
        pageIndex: 1,
        pageCount: 10,
        TotalCount: 0,
        imageState: "-1",
        addTime: [
          moment()
            .subtract(3, "month")
            .format("YYYY-MM-DD"), // 三个月前
          moment().format("YYYY-MM-DD"), // 当前日期
        ],
      }),
        this.getReportList();
    },
  },
  activated() {},
  created() {
    this.GetReportModality();
    this.getReportList();
    this.getALLHospitalList();
  },
};
</script>

<style lang="scss" scoped>
.doctorPage.managerPlan.Manager .addbtn-box {
  position: absolute;
  right: 10px;
  bottom: 16px;
  display: flex;
  align-items: center;
  .addbtn {
    position: initial;
    margin-right: 10px;
    margin-top: 0;
  }
}
.el-select.multiple {
  width: 300px;
  ::v-deep .el-input {
    .el-input__inner {
      height: 30px !important;
    }
  }
  ::v-deep .el-select__tags {
    margin-left: 10px;
    .el-tag--info {
      display: flex;
      margin: 0;
      .el-select__tags-text {
        display: block;
        max-width: 150px;
        line-height: 28px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  ::v-deep .el-tag__close.el-icon-close {
    top: 50%;
    transform: scale(0.7) translate(0, -50%);
  }
}
</style>
